import React from "react";
import { MdEmail } from "react-icons/md";
import "./topRibbon.scss";
import { CONTACT_DETAILS } from "../../../constants/contactDetails";

const TopRibbon: React.FC = (): JSX.Element => {
	return (
		<div className="ribbon-main-container">
			<div className="left-section"></div>
			<div className="right-section">
				<div className="contact-links">
					{/* `currentColor`, not a literal (D-035): the icon then follows
					    `--ribbon-text` from the stylesheet instead of pinning white
					    into the markup where no theme can reach it. */}
					<MdEmail color="currentColor" />
					<span style={{ marginLeft: "0.3rem" }}>{CONTACT_DETAILS.email}</span>
				</div>
			</div>
		</div>
	);
};

export default TopRibbon;
